module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Sun-glasses-8d8249316006c6881ff5bebde42a5eb1.svg";